import React from 'react';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Erreur capturée :', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '40px',
          textAlign: 'center',
          fontFamily: 'system-ui, sans-serif',
          background: '#fff',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <h1 style={{ color: '#d32f2f', fontSize: '28px', marginBottom: '16px' }}>
            Une erreur est survenue
          </h1>
          <p style={{ color: '#666', marginBottom: '24px' }}>
            Mais pas de panique, Nsara est solide comme le roc de Siby !
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#1B6B4A',
              color: 'white',
              border: 'none',
              padding: '14px 28px',
              borderRadius: '16px',
              fontWeight: '700',
              fontSize: '16px',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
          >
            Recharger Nsara
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;